import React, { Component } from "react";
import { reaction, toJS } from "mobx";
import { observer, inject } from "mobx-react";
import PropTypes from "prop-types";
import generateStoreList from "./methods";
import { jumpToTopHideHeader, isClientADesktop } from "../../utils";
import { Img, Utils } from "arv-reactcomponents";
import { Endpoints } from "npmlinks-constants";

@inject("StoreListStore", "CommonStore")
@observer
class StoreList extends Component {
  static customScrollBar(isDesktop) {
    return isDesktop ? "nwc-custom-scrollbar" : "";
  }

  constructor(props) {
    super(props);
    this.storeClick = false;
    this.watchForStoreSelection = this.watchForStoreSelection.bind(this);
    this.watchForStoreSelection();
  }

  // componentDidMount() {
  //   this.handleBrowserBack();
  // }

  get storeList() {
    return !this.props.StoreListStore.states.showStoreList ? "nwc-hide" : "";
  }

  get noStoreImage() {
    return !this.props.StoreListStore.states.showNoStoreImage ? "nwc-hide" : "";
  }

  get storeLoader() {
    return !this.props.StoreListStore.states.showStoreLoader ? "nwc-hide" : "";
  }

  get storePlaceholderImage() {
    return !this.props.StoreListStore.states.storePlaceholderImage
      ? "nwc-hide"
      : "";
  }

  watchForStoreSelection() {
    const { isDesktop } = this.props.CommonStore;
    reaction(
      () => this.props.StoreListStore.selectedStoreFCID,
      fcId => {
        if (isDesktop) {
          const storeListDesk = document.getElementsByClassName(
            "nwc-storeform-container",
          )[0];
          const storeLi = storeListDesk.getElementsByClassName(
            `nwc-store-${fcId}`,
          )[0];
          Utils.scrollElemToTop(storeListDesk, storeLi);
          Utils.scrollTo(storeListDesk, 0, storeListDesk.scrollTop - 60);
        } else {
          const storeListUl = document.getElementsByClassName(
            "nw-store-list",
          )[0];
          const storeLi = storeListUl.getElementsByClassName(
            `nwc-store-${fcId}`,
          )[0];
          Utils.scrollElemToTop(storeListUl, storeLi);
        }
        if (!isDesktop) {
          jumpToTopHideHeader();
        }
      },
      {
        context: this,
        compareStructural: true,
        delay: 100,
      },
    );

    reaction(
      () => this.props.StoreListStore.states.showNoStoreImage,
      flag => {
        if (flag) {
          // setTimeout(() => {
          if (isDesktop) {
            const storeListUl = document.getElementsByClassName(
              "nwc-storeform-container",
            )[0];
            Utils.scrollTo(storeListUl, 0, storeListUl.scrollTop + 200);
          } else {
            Utils.scrollTo(document.body, 0, document.body.scrollTop + 200);
          }
          // }, 200);
        }
      },
      {
        context: this,
        compareStructural: true,
        delay: 100,
      },
    );
  }

  render() {
    const { isDesktop } = this.props.CommonStore;
    const storeList = toJS(this.props.StoreListStore.storesList);
    const { appliedBrandName } = this.props.StoreListStore;
    let storeListHtml = "";
    let storeListLength = 0;
    if (storeList !== undefined) {
      storeListHtml = generateStoreList.component(storeList);
      storeListLength = storeListHtml.length;
    }
    return (
      <div className="nw-stores-panel">
        <div className={`nw-store-list-wrapper ${this.storeList}`}>
          <div
            className={`nw-store-list-heading nwc-stckyclass nw-store-list-heading${storeListLength}`}
          >
            <strong>
              {storeListLength}
              {` ${appliedBrandName}`}
            </strong>
            {storeListLength.length === 1 ? ` store ` : ` stores `}
            {`near you`}
          </div>
          <ul className={`nw-store-list clearfix ${StoreList.customScrollBar(isDesktop)}`}>
            {storeListHtml}
          </ul>
        </div>

        <div className={`nw-locator-image ${this.storePlaceholderImage}`}>
          <Img
            className="nw-nostore-img-tag"
            src={Endpoints.storeLocator_illustration}
            alt="stores placeholder"
          />
        </div>
        <div className={`nw-store-loader ${this.storeLoader}`} />
        <div className={`nw-stores-found-gif-container ${this.noStoreImage}`}>
          <Img
            className="nw-nostore-img-tag"
            src={Endpoints.NOSTORES}
            alt="no stores image"
          />
          <div className="nw-stores-found-error-msg">
            <h4>OOPS!!</h4>
            <p className="nw-no-stores-msg">
              We searched far and wide, could not find any stores matching your
              request
            </p>
          </div>
        </div>
      </div>
    );
  }
}

StoreList.wrappedComponent.propTypes = {
  StoreListStore: PropTypes.shape({
    selectedStoreFCID: PropTypes.string,
    fetchStores: PropTypes.func.isRequired,
    setStates: PropTypes.func.isRequired,
    storesList: PropTypes.object.isRequired,
    setMobileMapView: PropTypes.func.isRequired,
    resetMobileView: PropTypes.func.isRequired,
    states: PropTypes.object.isRequired,
    appliedBrandName: PropTypes.string,
  }).isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

export { default as Store } from "./Store";

const getFinalComponent = component =>
  inject("StoreListStore", "CommonStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: StoreList.wrappedComponent,
  component: StoreList,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/StoreList/index.js